/** @format */

import styled from "styled-components";
import { fonts } from "../../../css/variables";
import { statusMappingObj } from "../../../constance/constance";

type LabelStyleType = {
  status: string;
};

const LabelStyle = styled.div`
  background: ${(props: LabelStyleType) => {
    //背景色
    switch (props.status) {
      case "success":
        return "#E9F3FF";
      case "error":
        return "#FFEEEF";
      case "closed":
        return "#F1F4FC";
      default:
        return "#4D6EAE";
    }
  }};
  border: solid 1px
    ${(props: LabelStyleType) => {
      switch (props.status) {
        case "success":
          return "None";
        case "error":
          return "#FCAFB2";
        case "closed":
          return "#E0E0E0";
        default:
          return "#4D6EAE";
      }
    }};
  color: ${(props: LabelStyleType) => {
    switch (props.status) {
      case "success":
        return "#4D6EAE";
      case "error":
        return "#D34747";
      case "closed":
        return "#808080";
      default:
        return "#4D6EAE";
    }
  }};
  font-size: ${fonts.fontSizeRem("s")};
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  line-height: 100%;
  font-weight: bold;
`;

const StatusLabel = ({ status }: { status: string }) => {
  const statusBackgroundColor = (status: string) => {
    const statusBackgroundColorObj = {
      ENTRING: "success",
      ENTRY_OK: "success",
      CHECKING: "success",
      WAITING: "success",
      FIXED: "success",
      CHECK_NG: "error",
      INHOUSE_REVIEW: "success",
      INHOUSE_REVIEW_NG: "error",
      EXTERNAL_REVIEW: "success",
      EXTERNAL_REVIEW_NG: "error",
      WAITING_FINAL_AGREEMENT: "success",
      FIXED_FINAL_AGREEMENT: "success",
      CUTOVER: "success",
      CLOSING: "success",
      CLOSED: "closed",
    };
    return statusBackgroundColorObj[status as keyof typeof statusBackgroundColorObj];
  };

  const statusMappingText = (status: string) => {
    return statusMappingObj[status];
  };

  return <LabelStyle status={statusBackgroundColor(status)}>{statusMappingText(status)}</LabelStyle>;
};

export default StatusLabel;
